import React, { useState, useEffect, useCallback } from "react";
import LoadingInComponent from "../../Components/LoadingInComponent";
import ImportLogTable from "../../Components/Tables/ImportLogTable";
import { useToast } from "../../Components/Toast";
import axios from "axios";
import { GET_IMPORT_LOG_LIST_API } from "../../Constant/api";
import Breadcrumb from "../../Components/Breadcrumb";

const ImportLogList = () => {
  const [loading, setLoading] = useState(false);
  const [importsData, setImportsData] = useState([]);
  const [importsMeta, setImportsMeta] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [perPage, setPerPage] = useState(10);

  const { toast } = useToast();

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchImportsData(1, e.target.value);
  };

  const clearFilter = () => {
    setSearchTerm("");
    setIsSearchCleared(true);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchImportsData();
    }
  };

  const fetchImportsData = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      axios
        .get(GET_IMPORT_LOG_LIST_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            page: page,
            eventId: sessionStorage.getItem("event_id"),
            perPage: perPage,
            search: searchTerm,
          },
        })
        .then((response) => {
          setLoading(false);
          setImportsData(response.data.data);
          setImportsMeta(response.data.meta.pagination);
        })
        .catch((error) => {
          console.error("Error fetching `imports`:", error);
          setLoading(false);
          toast("Failed to fetch import logs.", "error");
        });
    } catch (error) {
      setLoading(false);
      toast("Failed to fetch import logs.", "error");
      console.error("Error fetching `imports`:", error);
    }
  }, [perPage, searchTerm, toast]);

  const handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    fetchImportsData(selectedPage);
  };

  useEffect(() => {
    fetchImportsData();
  }, [fetchImportsData]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchImportsData();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchImportsData]);

  const breadcrumbItems = [
    { label: "Guest List Import Log" },
    { label: "List" },
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <LoadingInComponent isLoading={loading}>
        {!loading && (
          <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[24px]">
            {/* Breadcrumb */}
            <Breadcrumb items={breadcrumbItems} />

            {/* Title row */}
            <div className="flex w-full justify-between items-center">
              <h2 className="text-[29px]">Guest List Import Log</h2>
            </div>

            {/* Guest list table */}
            <div className="w-full">
              <ImportLogTable
                type="list"
                data={importsData}
                meta={importsMeta}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleKeyDown={handleKeyDown}
                handlePageClick={handlePageClick}
                perPage={perPage}
                handlePerPageChange={handlePerPageChange}
                clearFilter={clearFilter}
              />
            </div>
          </div>
        )}
      </LoadingInComponent>
    </div>
  );
};

export default ImportLogList;
